const siteData = {
    name: "Fajny React",
    version: "1.0",
    email: "julien.sebag@me.com",
    description:
        "Documentation for Fajny React. Build responsive web projects with Fajny CSS, a simple and lightweight React Framework with a lot of components.",
    url: "",
    author: "Julien Sebag",
    type: "framework_documentation",
    lang: "en",
    coverOg: "/images/cover-og.png",
    githubUsername: "JulSeb42",
    favicon: "favicon.svg",
    year: 2022,

    logo: "/images/logo-fajny-css.svg",
    logoWhite: "/images/logo-fajny-css-white.svg",
    github: "https://github.com/fajny-css",
    figma: "https://www.figma.com/file/PEVWTQAsJjUmuxnWwxFwQg/Fajny-CSS-V3/duplicate",
    linkPortfolio: "https://www.julien-sebag.com/",

    npmReact: "$ npm i fajny-react",
    npmUtils: "$ npm i js-utils-julseb",
    cssReact: 'import "fajny-react/fajny.css"',
    urlNpm: "https://www.npmjs.com/package/fajny-react",

    urlFajnyHtml: "https://fajny-css.github.io/",

    keywords: [
        "css",
        "framework css",
        "ui design",
        "ux design",
        "scss",
        "sass",
        "components",
        "component library",
        "design system",
        "fajny css",
        "html",
        "responsive",
        "icon font",
        "icons",
    ],
}

export default siteData
